import { Bars4Icon, Squares2X2Icon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import CardViewOpportunities from '@/components/Opportunites/CardViewOpportunities';
import TableViewOpportunities from '@/components/Opportunites/TableViewOpportunities';
import SectionHeading from '@/components/SectionHeading';
import useAccessControl from '../../../../hooks/useAccessControl';
import type { RootState } from '../../../../store';
import { listOpportunities } from '../../../../store/Opportunity';

function ListLoader() {
  return (
    <section className='grid grid-cols-1 lg:grid-cols-4 md:grid-cols-3 gap-5'>
      {[0, 0, 0, 0].map((_, index) => (
        <div key={index + 1} className='my-2 w-auto shadow-md rounded relative'>
          <div className='animate-pulse'>
            <div className='bg-neutralColor-light h-64 w-full'></div>
            <div className='p-2'>
              <div className='h-4 bg-neutralColor-light rounded w-1/4 my-2'></div>
              <div className='space-y-2'>
                <div className='h-4 bg-neutralColor-light rounded mb-2'></div>
              </div>
              <div className='space-y-2'>
                <div className='h-4 bg-neutralColor-light rounded w-2/3 mb-2'></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

function AllOpportunites() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [projectView, setProjectView] = useState('card');
  const accessControl = useAccessControl();

  useEffect(() => {
    dispatch(listOpportunities() as any);
  }, [dispatch]);

  const { opportunities, fetching } = useSelector((state: RootState) => state.opportunity.opportunityMain);

  if (fetching) {
    return (
      <div className='container mx-auto'>
        <ListLoader />
      </div>
    );
  }
  const viewChangedHandler = (listType: string) => {
    setProjectView(listType);
  };

  return (
    <div className='container mx-full mx-auto'>
      <div className='mt-4'>
        <SectionHeading
          title='Opportunities'
          btnText='New Opportunity'
          includePrimaryBtn={accessControl.canAccess(['SUPER_ADMIN'])}
          buttonClickHandler={() => navigate(`${location.pathname}/new`)}
        />
      </div>

      <div className='flex justify-end gap-2 my-4 text-neutralColor-normal'>
        <div
          className={`p-2 rounded-md cursor-pointer hover:bg-primaryColor-normal hover:text-white transition duration-200 ease-in-out ${
            projectView === 'list' && 'bg-primaryColor-normal text-white'
          }`}
          onClick={() => viewChangedHandler('list')}
        >
          <Bars4Icon className='h-6 w-6' />
        </div>
        <div
          className={`p-2 rounded-md cursor-pointer hover:bg-primaryColor-normal hover:text-white transition duration-200 ease-in-out ${
            projectView === 'card' && 'bg-primaryColor-normal text-white'
          }`}
          onClick={() => viewChangedHandler('card')}
        >
          <Squares2X2Icon className='h-6 w-6' />
        </div>
      </div>
      {projectView === 'card' && <CardViewOpportunities opportunities={opportunities} />}
      {projectView === 'list' && <TableViewOpportunities opportunities={opportunities} />}
      {opportunities && opportunities.length === 0 && (
        <section className='grid grid-cols-1 lg:grid-cols-4 md:grid-cols-3 gap-5'>
          <div className='text-center mt-8 rounded-md p-5 bg-white shadow-xl'>
            <svg className='mx-auto h-12 w-12 text-gray-400' fill='none' viewBox='0 0 24 24' stroke='currentColor' aria-hidden='true'>
              <path
                vectorEffect='non-scaling-stroke'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z'
              />
            </svg>
            <h3 className='mt-2 text-sm font-medium text-gray-900'>No Opportunites</h3>
          </div>
        </section>
      )}
    </div>
  );
}

export default AllOpportunites;
